import moment from 'moment';

import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';
import downloadFile from '../../util/download';

export const ERROR = 'MONTECARLOTASKS_ERROR';
export const LOADING = 'MONTECARLOTASKS_LOADING';
export const SUCCESS = 'MONTECARLOTASKS_SUCCESS';
export const SIM_SUCCESS = 'MONTECARLOTASKS_SIM_SUCCESS';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data
  };
}

function successSimulation(data) {
  return {
    type: SIM_SUCCESS,
    data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { allCustomFields, dates, enabledColors, mct } = getState().filters;

    const customFields = customFieldsUtils.getSelected(allCustomFields, mct);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const tData = await worker.Throughput({
        lists: mct.selectedLists,
        labels: mct.selectedLabels,
        members: mct.selectedMembers,
        customFields,
        color: true,
        timeUnit: 'day',
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        fillMissingDates: true
      });
      dispatch(success(tData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getSimulationResults(baseData) {
  return async (dispatch, getState) => {
    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { mct } = getState().filters;

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data);
    try {
      const simData = await worker.MonteCarloTasks({
        baseData,
        startDate: moment(mct.startDate).toISOString(),
        endDate: moment(mct.endDate).toISOString(),
        trials: mct.trials,
        scale: mct.scale
      });

      dispatch(successSimulation(simData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function exportResults(baseData) {
  return async (dispatch, getState) => {
    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { mct } = getState().filters;

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data);
    try {
      const json = await worker.ExportMonteCarloTasks({
        baseData,
        startDate: moment(mct.startDate).toISOString(),
        endDate: moment(mct.endDate).toISOString(),
        trials: mct.trials,
        scale: mct.scale
      });
      const filename = `mct_raw_${moment(mct.startDate).format('YYYY-M-D')}_${moment(mct.endDate).format(
        'YYYY-M-D'
      )}.txt`;

      const blob = new Blob([JSON.stringify(json, null, 2)], { type: 'text/plain;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      downloadFile(url, filename);
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
